module.exports = __webpack_public_path__ + "img/ico-circle-checked.ec6d6e1f.svg";